import { SelectedBatches } from '../../BatchesList/typings';
import { CanvasApiBaseResponse } from '../../common/requestsTypings';
import { DEFAULT_FETCH_LIMIT, Order, SharedData } from '../../common/typings';
import { GetCommonCreativesResponse } from '../../CommonCreatives/typings';

import { CreativesApiMethodExecutor } from './CreativesApiMethodExecutor';

const PATH = 'creatives-batches';

export class CommonCreativesApiMethodExecutor extends CreativesApiMethodExecutor {
    constructor() {
        super(PATH);
    }

    async getCreatives(offset: number, order: Order, sharedData: SharedData) {
        const queryParams = [`sort_order=${order}`, 'sort_by=date', `limit=${DEFAULT_FETCH_LIMIT}`, `offset=${offset}`];

        return this.createRequest<GetCommonCreativesResponse>(
            PATH,
            {
                method: 'GET'
            },
            sharedData,
            queryParams
        );
    }

    async submit(batches: SelectedBatches, sharedData: SharedData): Promise<CanvasApiBaseResponse> {
        return await this.createRequest<CanvasApiBaseResponse>(
            'direct/creatives',
            {
                method: 'POST',
                body: JSON.stringify({ batches })
            },
            sharedData
        );
    }
}
